import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShoppingBag1"><Path fillRule="evenodd" clipRule="evenodd" d="M4.0625 3H19.9414L21.0664 21H2.9375L4.0625 3ZM10.002 8V7H8.00195V8C8.00195 10.2091 9.79281 12 12.002 12C14.2111 12 16.002 10.2091 16.002 8V7H14.002V8C14.002 9.10457 13.1065 10 12.002 10C10.8974 10 10.002 9.10457 10.002 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag1;
